export default __webpack_public_path__ + "20e0ef243af8a5da8211d6eda3639cdd.png";